import { getAll } from '@/api/logistique/tourneeFaceSemaine/';
import { NO_PAGINATION } from '@/configuration/clientTableConf';

export default async function updateInfoLogistiqueLigneCmd(commande) {
  if (commande.lignesCommande.length === 0) return;
  const idsLignesCmd = commande.lignesCommande.map((ligne) => { return ligne.id; });
  const allTfs = (await getAll({
    limit: NO_PAGINATION,
    query: {
      societeId: commande.societeId,
      affectationLogistiqueLigneCommandeIds: idsLignesCmd,
    },
  })).data.result.items;
  commande.lignesCommande.forEach((ligne) => {
    const tfsAffectees = allTfs.filter((tfs) => {
      return tfs.affectationLogistiqueLigneCommandeId === ligne.id;
    });
    ligne.isAffecteLogistiquement = (tfsAffectees && tfsAffectees.length > 0)
      || (ligne.demandesLogistique && ligne.demandesLogistique.length > 0);
    ligne.tfsAffectees = tfsAffectees;
  });
}
